import { HUText } from "@modules/ui/components/huText"
import { HUFontStyle } from "@modules/ui/styles/font"
import { useTheme } from "styled-components"
import { CheckmarkIcon } from "@images/svgIcons/checkmarkIcon"
import { PendingIcon } from "@images/svgIcons/pendingIcon"
import { ErrorIcon } from "@images/svgIcons/status/errorIcon"
import { InTransitFailedIcon } from "@images/svgIcons/status/inTransitFailedIcon"
import { InTransitIcon } from "@images/svgIcons/status/inTransitIcon"
import { PayoutTransferStatus } from "@modules/finances/types/financesType"
import { getPayoutStatusWord } from "@modules/financesPayout/entities/payoutUtils"

type PayoutStatusWithIconProps = {
  payoutStatus: PayoutTransferStatus
  size?: number
  color?: string
  fontStyle?: HUFontStyle
  colorText?: string
} & React.HTMLAttributes<HTMLDivElement>

export const PayoutStatusWithIcon: React.FC<PayoutStatusWithIconProps> = ({
  payoutStatus,
  size,
  color,
  fontStyle,
  colorText,
  ...props
}) => {
  const theme = useTheme()

  const getIcon = () => {
    switch (payoutStatus) {
      case PayoutTransferStatus.PAID:
        return <CheckmarkIcon style={{ width: size ?? "24px", height: size ?? "24px" }} color={color ?? theme.sucess} />
      case PayoutTransferStatus.IN_TRANSIT:
        return <InTransitIcon size={size ?? 24} color={color ?? theme.sucess} />
      case PayoutTransferStatus.CANCELED:
        return <ErrorIcon style={{ width: size ?? "24px", height: size ?? "24px" }} color={theme.mainWhite} />
      case PayoutTransferStatus.PENDING:
        return <PendingIcon style={{ width: size ?? "24px", height: size ?? "24px" }} color={theme.warning} />
      case PayoutTransferStatus.FAILED:
        return <InTransitFailedIcon size={size ?? 24} color={theme.error} />
      default:
        return null
    }
  }

  return (
    <div className="flex gap-1 align-items-center" {...props}>
      {getIcon()}
      <HUText color={colorText ?? theme.blackAtheleWhiteOwner} fontStyle={fontStyle ?? "BM"}>
        {getPayoutStatusWord(payoutStatus)}
      </HUText>
    </div>
  )
}
